export default __webpack_public_path__ + "locales/uk-UA/ChangeEmailDialog.json?hash=b35bd1771a6ab5ab427ad1aa91fe3567";